// Keep an already-open product page from ordering after supplier evidence expires.
// Shopify inventory policy remains the checkout control; this never enables a button.
(() => {
  function allowed(evidence, variantId, now) {
    return evidence.remoteVariant === variantId &&
      evidence.remoteState === 'remote' &&
      Number(evidence.remoteExpiry) > now;
  }
  function guard(productInfo) {
    const evidence = productInfo.querySelector('[data-bfg-remote-state]');
    if (!evidence) return true; // Native physical stock keeps Shopify's behavior.
    const form = productInfo.querySelector('product-form form');
    const variantId = form?.querySelector('[name="id"]')?.value;
    const data = {
      remoteVariant: evidence.dataset.bfgRemoteVariant,
      remoteState: evidence.dataset.bfgRemoteState,
      remoteExpiry: evidence.dataset.bfgRemoteExpiry
    };
    if (allowed(data, variantId, Math.floor(Date.now() / 1000))) return true;
    const button = form?.querySelector('[name="add"]');
    if (button) {
      button.disabled = true;
      const label = button.querySelector('span');
      if (label && label.textContent !== window.variantStrings?.soldOut) {
        label.textContent = window.variantStrings?.soldOut || evidence.dataset.bfgRemoteUnavailable;
      }
    }
    evidence.style.color = '';
    if (evidence.textContent !== evidence.dataset.bfgRemoteUnavailable) {
      evidence.textContent = evidence.dataset.bfgRemoteUnavailable;
    }
    return false;
  }
  function refresh() { document.querySelectorAll('product-info').forEach(guard); }
  document.addEventListener('submit', (event) => {
    if (!event.target.matches('product-form form')) return;
    const info = event.target.closest('product-info');
    if (info && !guard(info)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('DOMContentLoaded', refresh, { once: true });
  new MutationObserver(refresh).observe(document.documentElement, { childList: true, subtree: true });
  window.setInterval(refresh, 1000);
  refresh();
})();
